import { ca } from '@cian/analytics';

export function trackOffersEscrouLabelClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'Click',
    label: 'flats_escrow',
    useLastProducts: true,
  });
}
